__turbopack_context__.v({
  "nav-container": "tab-container-block-module-scss-module__8IZVOq__nav-container",
  "nav-menu": "tab-container-block-module-scss-module__8IZVOq__nav-menu",
  "tab": "tab-container-block-module-scss-module__8IZVOq__tab",
  "tabs": "tab-container-block-module-scss-module__8IZVOq__tabs",
});
